module.exports = __webpack_public_path__ + "static/media/phone.c908de24.svg";